import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RestApiModel } from '../../../shared/model/rest-api.model';
import { IssueRelatedQuestionModel } from '../model/issue.related.question.model';

@Injectable()
export class QuestionService {
  protected questionURL = RestApiModel.STARGATE_API_URL + '/issue';
  protected formsEditUrl = RestApiModel.FORMS_API_URL + '/upsertForm';
  constructor(private http: HttpClient) {}
  /**
   * Get question list.
   * @returns {Observable<any>}
   */
  getQuestions(issueId: string): Observable<any> {
    let Url: any;
    Url = this.questionURL + '/' + issueId + '/questions';
    return this.http.get(Url).pipe(
      map((res: any) => res),
      catchError(error => Observable.of(error))
    );
  }
  /**
   * Call upsertForms mutation
   * @returns {Observable<any>}
   */
  upsertQuestions(questions: IssueRelatedQuestionModel): Observable<any> {
    let Url: any;
    Url = this.formsEditUrl;
    return this.http.post(Url, questions).pipe(
      map((res: any) => res),
      catchError(error => Observable.of(error))
    );
  }

  /**
   * Get Priority list for Customer.
   * @returns {Observable<any>}
   */
  getCustomerPriorities(): Observable<any> {
    const customerNumber = localStorage.getItem('cNum');
    if (customerNumber) {
      return this.http
        .get(
          RestApiModel.PROXY_API_URL +
            '/customer/' +
            customerNumber +
            '/priorities'
        )
        .pipe(
          map((res: any) => res),
          catchError(error => Observable.of(error))
        );
    }
  }
}
